import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
/*
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button/Button';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n'; */
import TitleDisplay from '../../../../Shared/Containers/TitleDisplay';
// import { ResetIcon } from '../../../../../Icons';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      // position: "absolute",
      alignItems: 'center',
      padding: 0,
      margin: theme.spacing(0, 3),
      width: `calc(100% - ${theme.spacing(6)}px)`,
      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(0, 3 * theme.spacingMultiplicator.md),
        width: `calc(100% - ${theme.spacing(6 * theme.spacingMultiplicator.md)}px)`,
      },
      [theme.breakpoints.up('xl')]: {
        margin: theme.spacing(0, 2 * theme.spacingMultiplicator.xl),
        width: `calc(100% - ${theme.spacing(4 * theme.spacingMultiplicator.xl)}px)`,
      },
    },
    button: {
      marginLeft: 'auto',
      textTransform: 'none',
      lineHeight: theme.typography.body1.fontSize,
      borderRadius: 100,
      padding: '18px 10px',
      marginTop: -8,
      marginRight: -9,

      '&:hover, &:active, &:focus': {
        boxShadow: 'none',
        background: 'transparent',
      },

      [theme.breakpoints.up('sm')]: {
        marginRight: -15,
        paddingLeft: 15,
        '&:hover': {
          background: '#F2F2F2',
        },
        '&:active, &:focus': {
          background: '#C9C9C9',
        },
      },
      height: 23,
      '& p': {
        lineHeight: `${23}px`,
        height: 23,
      },
    },
    buttonIcon: {
      marginLeft: 'auto',
      width: 48,
      fontSize: 48,
      position: 'relative',
      top: -2,
      marginTop: 5,
      padding: 5,
      marginRight: -5,
      '&:hover': {
        boxShadow: 'none',
        background: '#F2F2F2',
        borderRadius: 100,
      },
      '&:active, &:focus': {
        boxShadow: 'none',
        background: '#C9C9C9',
        borderRadius: 100,
      },
      [theme.breakpoints.up('sm')]: {
        padding: 0,
        marginRight: -6,
        '&:hover, &:active, &:focus': {
          background: 'transparent',
        },
      },
    },
    resetTypography: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'initial',
      },
    },
  }),
  { name: 'ResetViewRow' },
);

const ResetViewRow = (props) => {
  const classes = useStyles(props);
  /* const {
    onReset, resetWithConfiguration, configuratorState, currentDesignerData,
    currentDesignData, originalConfigurationData, globalState, isCreator,
  } = props; */

  /* const onResetFunc = () => {
    props.resetWithConfiguration(props.globalState/* ,...originalConfigurationData, designdata: currentDesignData} *//* , currentDesignerData);
  };
  */
  return (
    <div className={clsx('resetviewrow', classes.root)}>
      <TitleDisplay />
      {/* }  <Button
        disableRipple
        className={classes.button}
        onClick={onResetFunc}
      >
        <Typography className={classes.resetTypography} variant="body1">
          {isCreator ? t('resetRow.resetCreator') : t('resetRow.resetDesigner')}

        </Typography>
      <ResetIcon className={classes.buttonIcon} />
      </Button> */}
    </div>
  );
};

export default ResetViewRow;
